import { getCookie, createCookie } from '@shopee/cookie';
import {
  BusinessLanguageConfig,
  BusinessTarget,
  Language,
  Locale,
} from '@shopee-user/global';

const LANGUAGE_KEY_IN_COOKIES = 'language';

export function isValidLanguage(cookieLang: string): boolean {
  return (
    !!BusinessLanguageConfig[__BUSINESS_TARGET__ as BusinessTarget][
      __LOCALE__ as Locale
    ] &&
    BusinessLanguageConfig[__BUSINESS_TARGET__ as BusinessTarget][
      __LOCALE__ as Locale
    ].languageOptions.indexOf(cookieLang as Language) !== -1
  );
}

export function getUserLanguage(): Language {
  const cookieLang = getCookie(LANGUAGE_KEY_IN_COOKIES);

  if (cookieLang && isValidLanguage(cookieLang)) {
    return cookieLang as Language;
  }

  return BusinessLanguageConfig[__BUSINESS_TARGET__ as BusinessTarget][
    __LOCALE__ as Locale
  ]
    ? BusinessLanguageConfig[__BUSINESS_TARGET__ as BusinessTarget][
        __LOCALE__ as Locale
      ].defaultLanguage
    : Language.en;
}

export function setUserLanguage(language: string): Language | undefined {
  if (!language || !isValidLanguage(language)) {
    const cookieLang = getUserLanguage();
    createCookie(LANGUAGE_KEY_IN_COOKIES, cookieLang);
    return cookieLang as Language;
  }

  createCookie(LANGUAGE_KEY_IN_COOKIES, language);
  return language as Language;
}
